/**
 * Deterministic avatar colour: the same sender keeps the same colour across
 * sessions and screens, and the colour is a TOKEN, never a literal.
 *
 * One palette for the whole app (ADR 0048 §6): this is the hash contacts'
 * `routes/contacts/swatch.ts` uses, so a person is the same colour in the
 * message list as in their contact card. That file becomes a re-export of this
 * one when the contacts chunk merges; until then the two must not drift.
 */
export function avatarColor(key: string): string {
  let hash = 0;
  for (let index = 0; index < key.length; index += 1) {
    hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
  }
  return `var(--color-account-${(hash % 4) + 1})`;
}

/**
 * The one letter a list avatar shows: the first letter or digit of the
 * display name, else of the address, else nothing. `Intl.Segmenter` is not
 * needed for one grapheme of a name; `Array.from` keeps an astral character
 * (an emoji display name) whole instead of splitting its surrogate pair.
 */
export function avatarInitial(name: string | undefined, email: string): string {
  for (const source of [name, email]) {
    const match = Array.from(source ?? '').find((char) => /[\p{L}\p{N}]/u.test(char));
    if (match) return match.toLocaleUpperCase();
  }
  return '';
}
